import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMembersQuery } from '../features/members/membersApi';
import { useGetProjectsQuery } from '../features/projects/projectsApi';
import {
  useAddTaskMutation,
  useEditTaskMutation,
  useGetTaskQuery,
} from '../features/tasks/tasksApi';
import handleInput from '../util/handleInput';

const TaskForm = ({ editMode, id }) => {
  const { data: members } = useGetMembersQuery();
  const { data: projects } = useGetProjectsQuery();
  const [editTask] = useEditTaskMutation();
  const { data: task } = useGetTaskQuery(id);
  const [addTask] = useAddTaskMutation();
  const navigate = useNavigate();

  const initialFormData = {
    taskName: '',
    teamMember: {},
    projectName: {},
    deadline: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const { taskName, teamMember, projectName, deadline } = formData;

  useEffect(() => {
    if (editMode && task) {
      setFormData({
        ...task,
        teamMember: task.teamMember.id,
        projectName: task.project.id,
      });
    }
  }, [editMode, task]);

  const handleChange = (e) => {
    const inputValue = handleInput(e);

    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [e.target.name]: inputValue,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedMember = members.find(
      (member) => member.id === Number(teamMember)
    );
    const selectedProject = projects.find(
      (project) => project.id === Number(projectName)
    );

    if (editMode) {
      editTask({
        id,
        data: {
          ...formData,
          teamMember: selectedMember,
          project: selectedProject,
        },
      });
    } else {
      addTask({
        ...formData,
        teamMember: selectedMember,
        project: selectedProject,
      });
    }

    navigate('/');
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={taskName}
          onChange={handleChange}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          required
          value={teamMember}
          onChange={handleChange}
        >
          <option value="" hidden>
            Select Job
          </option>
          {members?.map((member) => (
            <option key={member.id} value={member.id}>
              {member.name}
            </option>
          ))}
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          required
          value={projectName}
          onChange={handleChange}
        >
          <option value="" hidden>
            Select Project
          </option>
          {projects?.map((project) => (
            <option key={project.id} value={project.id}>
              {project.projectName}
            </option>
          ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          required
          value={deadline}
          onChange={handleChange}
        />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit">
          Save
        </button>
      </div>
    </form>
  );
};

export default TaskForm;
